import http from "../http-common";
import authFileHeader from './auth-file-header';

class UploadFilesService {

    uploadUserList(file, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);

        return http.post(
            "/upload/user", formData,
            {
                headers: authFileHeader(),
                onUploadProgress
            });
    }

    uploadUserImage(file, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);

        return http.post(
            "/upload/user-image", formData,
            {
                headers: authFileHeader(),
                onUploadProgress
            });
    }

    getFiles() {
        return http.get("/files");
    }
}

export default new UploadFilesService();